import { State } from 'src/redux/reducers'

export const getNormalizedData = (state: State) => state.normalizedData
